import React, { useState, useEffect } from 'react';
import NavigationBar from '../navbar/NavigationBar';
import DownloadIcon from '@mui/icons-material/Download';
import {
  Container,
  Typography,
  Grid,
  Card,
  Divider,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  styled,
  createTheme,
  ThemeProvider,
  Box,
  CardMedia,
  Button,
} from '@mui/material';
import moment from 'moment';
import Footer from '../navbar/Footer';
const comptesNationauxData = [
       {
    "title": "Note sur les Comptes Nationaux Trimestriels -4ème Trimestre 2025",
    "principalLink": "/documents/ComptesNational/Note_analyse_CNT_T4_2025.pdf",
    "prixCourantLink": null,
    "prixConstantLink": null,
    "image": "assets/comptesNationaux/cover.PNG",
    "description": "Au quatrième trimestre de l’année 2025, une croissance réelle globale de l’activité économique de 3,7 % en comparaison avec le même trimestre de l’année 2024.",
    "date": "2026-04-06"
},
     {
    "title": "Note sur les Comptes Nationaux Trimestriels -3ème Trimestre 2025",
    "principalLink": "/documents/ComptesNational/Note_analyse_CNT_T3_2025.pdf",
    "prixCourantLink": null,
    "prixConstantLink": null,
    "image": "assets/comptesNationaux/cover.PNG",
    "description": "Au troisième trimestre de l’année 2025, une croissance réelle globale de l’activité économique de 2,1 % en comparaison avec le même trimestre de l’année 2024.",
    "date": "2026-02-06"
},

    {
    "title": "Note sur les Comptes Nationaux Trimestriels -2ème Trimestre 2025",
    "principalLink": "/documents/ComptesNational/Note_analyse_CNT_T2_2025.pdf",
    "prixCourantLink": null,
    "prixConstantLink": null,
    "image": "assets/comptesNationaux/cover.PNG",
    "description": "Au deuxième trimestre de l'année 2025, une croissance réelle globale de l'activité économique de 2,6 % en comparaison avec le même trimestre de l'année 2024.",
    "date": "2025-11-11"
},
    {
    "title": "Note sur les Comptes Nationaux Trimestriels -1er Trimestre 2025",
    "principalLink": "/documents/ComptesNational/Note_analyse_CNT_T1_2025_actualise_2eme_fois.pdf",
    "prixCourantLink": null,
    "prixConstantLink": null,
    "image": "assets/comptesNationaux/cover.PNG",
    "description": "Au premier trimestre de l'année 2025, une croissance réelle globale de l'activité économique de 1,7 % en comparaison avec le même trimestre de l'année 2024.",
    "date": "2025-07-11"
},
 
  {
    "title": "Note sur les Comptes Nationaux Trimestriels - 4ème Trimestre 2024",
    "principalLink": "/documents/ComptesNational/Note-danalyse__CNT-Constant_T4_2024-3.docx",
    "prixCourantLink": null,
    "prixConstantLink": null,
    "image": "assets/comptesNationaux/cover.PNG",
    "description": "Une croissance réelle globale de l’activité économique de 2,9% en comparaison avec le même trimestre de l’année 2023 due à l'accroissement des activités des secteurs : primaire (+2,6%), secondaire (+1 ,5%) et tertiaire (+3,5%).  ",
    "date": "2025-03-11"
},
{
  "title": "Mise en œuvre du Système de Comptabilité Nationale 2008 (SCN 2008) - Note d'analyse des résultats",
  "principalLink": "/documents/ComptesNational/LES-PRNCIPAUX-RESULTATS-REBASAGE-2016-1.pdf",
  "prixCourantLink": null,
  "prixConstantLink": null,
  "image": "assets/comptesNationaux/cover.PNG",
  "description": "Un PIB courant de 7 327,6 milliards de BIF sous le SCN 2008 contre 4 848,2 sous le SCN 1993, soit une réévaluation de 51,1%.",
  "date": "2024-07-11"
},
  {
    title: "Mise en œuvre du Système de Comptabilité Nationale 2008 (SCN 2008) et changement d'année de base au Burundi",
    principalLink: "/documents/ComptesNational/LES-PRNCIPAUX-RESULTATS-REBASAGE-2016-1.pdf",
    prixCourantLink: null,
    prixConstantLink: null,
    image: 'assets/comptesNationaux/cover.PNG', 
    description: "Une nouvelle structure de l’économie révèle une domination du secteur primaire (41,4% du PIB), suivi du secteur tertiaire (39,3%) et un secteur secondaire à un stade embryonnaire (13,6%).",
    date: "2024-07-11"
  },
  {
    title: "Comptes nationaux du 3ème Trimestre 2024",
    principalLink: "/documents/ComptesNational/Note-danalyse__CNT_T3_2024-_1_.pdf",
    prixCourantLink: null,
    prixConstantLink: "/documents/ComptesNational/T3_CNT_2024_SPES.xlsx",
    image: 'assets/comptesNationaux/cover.PNG', 
    description: "Une croissance réelle globale de l’activité économique de 3,2% en comparaison avec le même trimestre de l’année 2023 due à l'n accroissement des activités des secteurs : primaire (+3,6%), secondaire (+1 ,1%) et tertiaire (+4,1%). ",
    date: "2024-12-30"
  },
  {
    title: "Comptes nationaux du 2ème Trimestre 2024",
    principalLink: "/documents/ComptesNational/Note-danalyse__CNT_T2_2024-_2_.pdf",
    prixCourantLink: null,
    prixConstantLink: null,
    image: 'assets/comptesNationaux/cover.PNG', 
    description: "Une croissance réelle globale de l’activité économique de +4,0% en comparaison avec le même trimestre de l’année 2023 dont la performance freinée par le secteur secondaire de (-1.5%)",
    date: "2024-09-15"
  },
  {
    title: "Comptes nationaux du 1er Trimestre 2024",
    principalLink: "/documents/ComptesNational/Note-danalyse_format_CNT_T1-_2024-1.docx",
    prixCourantLink: null,
    prixConstantLink: null,
    image: 'assets/comptesNationaux/cover.PNG', 
    description: "Une croissance réelle globale de l’activité économique de +5,9% en comparaison avec le même trimestre de l’année 2023 due à l'accroissement des activités dans tous les secteurs : secteur primaire (+8,5%), secteur tertiaire (+6,4%) et le secteur secondaire (+1,0%). ",
    date: "2024-06-15"
  },
  {
    title: "Comptes nationaux du 4ème Trimestre 2023",
    principalLink: "/documents/ComptesNational/Note-danalyse_CNT_T4.pdf",
    prixCourantLink: null,
    prixConstantLink: null,
    image: 'assets/comptesNationaux/cover.PNG', 
    description: "Une croissance réelle globale de l’activité économique de +6,7% en comparaison avec le même trimestre de l’année 2022 due à l'accroissement des activités des secteurs primaire (+7,3%), secondaire (+8,3%) et tertiaire (+7,1%).",
    date: "2023-12-30"
  },
  {
    title: "Comptes nationaux du 3ème Trimestre 2023",
    principalLink: "/documents/ComptesNational/Note-danalyse_CNT_T3.pdf",
    prixCourantLink: null,
    prixConstantLink: null,
    image: 'assets/comptesNationaux/cover.PNG', 
    description: "Une croissance réelle globale de l’activité économique de +2,3% en comparaison avec le même trimestre de l’année 2022 due à l'accroissement des activités des secteurs primaire (+0,7%), tertiaire (+2,6%), le secondaire (+2,1%).",
    date: "2023-11-15"
  },
  {
    title: "Comptes nationaux du 2ème Trimestre 2023",
    principalLink: "/documents/ComptesNational/Note-danalyse_CNT_T2.pdf",
    prixCourantLink: null,
    prixConstantLink: null,
    image: 'assets/comptesNationaux/cover.PNG', 
    description: "Une croissance réelle globale de l’activité économique de +2,5% en comparaison avec le même trimestre de l’année 2022 due à l'accroissement des activités des secteurs primaire (+4,9%), secondaire (+3,9%) et le tertiaire (0.04%).",
    date: "2023-03-15"
  },
  {
    title: "Comptes nationaux du 1er Trimestre 2023",
    principalLink: "/documents/ComptesNational/Note-danalyse_CNT_T1.pdf",
    prixCourantLink: null,
    prixConstantLink: null,
    image: 'assets/comptesNationaux/cover.PNG', 
    description: "Une croissance réelle globale de l’activité économique de +1,9% en comparaison avec le même trimestre de l’année 2022 en faveur du à l'accroissement des activités du secteur tertiaire (+7,6%).",
    date: "2023-02-15"
  },
  {
    title: "Comptes nationaux du 4ème Trimestre 2019",
    principalLink: "/documents/ComptesNational/Note-danalyse_CNT_T4_2019-1.pdf",
    prixCourantLink: null,
    prixConstantLink: null,
    image: 'assets/comptesNationaux/cover.PNG',
    description: "Une décroissance de l’activité économique de 0,1% en comparaison avec le même trimestre en 2018 avec des chutes remarquées dans les secteurs secondaire (-4,2) et tertiaire (-6,1).",
    date: "2020-12-15"
  },
  {
    title: "Note de synthèse de l’activité économique du Burundi (Définitif 2018 et Provisoire 2019)",
    principalLink: "/documents/ComptesNational/NOTE-DE-SYNTHESE-DES-CN-DEFINITIFS-DE-2018ET-PROVISOIRE-DE-2019v06052021.pdf",
    prixCourantLink: null,
    prixConstantLink: null,
    image: 'assets/comptesNationaux/cover.PNG',
    description: "Un taux de croissance réel en 2018 de 5,3% contre 3,8% en 2017. De façon provisoire, le taux de croissance de 2019 est de 4,5%.",
    date: "2021-01-15"
  },
  {
    title: "Note de synthèse de l’activité économique du Burundi (Définitif 2017 et Provisoire 2018)",
    principalLink: "/documents/ComptesNational/NOTE-DE-SYNTHESE-DES-CN-DEFINITIFS-DE-2017-ET-PROVISOIRE-DE-2018-v06052021.pdf",
    prixCourantLink: null,
    prixConstantLink: null,
    image: 'assets/comptesNationaux/cover.PNG',
    description: "Un taux de croissance réel en 2017 de 3,8% contre 3,2% en 2016. De façon provisoire, le taux de croissance de 2018 est de 5,5%.",
    date: "2020-01-15"
  },
  {
    title: "Comptes nationaux définitifs de 2016 et provisoires de 2017",
    principalLink: "/documents/ComptesNational/RAPPORT-DES-COMPTES-NATIONAUX-DEFINITIFS-DE-2016-ET-PROVISOIRES-DE-2017-VF1.pdf",
    prixCourantLink: null,
    prixConstantLink: null,
    image: 'assets/comptesNationaux/cover.PNG',
    description: "Un taux de croissance réel en 2016 de 3,2% contre -0,4% en 2015. De façon provisoire, le taux de croissance de 2017 est de 4,2.",
    date: "2019-10-15"
  },
  {
    title: "Rapport des comptes 2016-2017",
    principalLink: "/documents/ComptesNational/Rapport-comptes-2016-2017.pdf",
    prixCourantLink: null,
    prixConstantLink: null,
    image: 'assets/comptesNationaux/cover.PNG',
    description: "Un taux de croissance réel en 2016 de 3,2% contre -0,4% en 2015. De façon provisoire, le taux de croissance de 2017 est de 4,2 ; ",
    date: "2019-11-15"
  },
  {
    title: "Comptes de la nation 2016",
    principalLink: "/documents/ComptesNational/CN-2016.pdf",
    prixCourantLink: null,
    prixConstantLink: null,
    image: 'assets/comptesNationaux/cover.PNG',
    description: "Un taux de croissance réel en 2016 de 3,2% contre -0,4% en 2015. De façon provisoire, le taux de croissance de 2017 est de 4,2.",
    date: "2019-11-15"
  },
  {
    title: "Comptes de la nation 2015",
    principalLink: "/documents/ComptesNational/CN-2015.pdf",
    prixCourantLink: "/documents/ComptesNational/TRE2015CRT.xls",
    prixConstantLink: "/documents/ComptesNational/TRE2015CST.xls",
    image: 'assets/comptesNationaux/cover.PNG',
    description: "Un taux de croissance réel de -0,4 % en 2015 contre 4,2% en 2014 en faveur des activités du secteur primaire dont le poids s’établit à 34,6% en 2015 contre 35,6% en 2014. ",
    date: "2018-11-15"
  },
  {
    title: "Comptes de la nation 2014",
    principalLink: "/documents/ComptesNational/Comptes-de-la-Nation-de-2014.pdf2_.pdf",
    prixCourantLink: "/documents/ComptesNational/TRE-2014-CRT-V.xls",
    prixConstantLink: "/documents/ComptesNational/TRE-2014-CST-V.xls",
    image: 'assets/comptesNationaux/cover.PNG',
    description: "Un taux de croissance réel en 2014 de 4,2% contre 4,9% en 2013 avec une contreperformance des activités du secteur primaire dont le poids s'établit à 35,6% en 2014 contre 36,7% en 2013.",
    date: "2016-12-01"
  },
  {
    title: "Comptes de la nation 2013",
    principalLink: "/documents/ComptesNational/Comptes-de-la-Nation-2013-.pdf",
    prixCourantLink: "/documents/ComptesNational/TRE-2013-CRT-V.xls",
    prixConstantLink: "/documents/ComptesNational/TRE-2013-CST-V.xls",
    image: 'assets/comptesNationaux/cover.PNG',
    description: "Un taux de croissance réel en 2013 de 4,9% contre 4,4% en 2012 avec une reprise du secteur primaire de 8,4%.",
    date: "2013-12-31"
  },/*




  {
    title: "Comptes de la nation 2012",
    principalLink: "/documents/ComptesNational/",
    prixCourantLink: "/documents/ComptesNational/TRE-2012-CRT-V.xls",
    prixConstantLink: "/documents/ComptesNational/TRE-2012-CST-V.xls",
    image: 'assets/comptesNationaux/cover.PNG', 
    description: "Une synthèse des comptes de la nation pour l'année 2012, portant une attention particulière aux tendances économiques observées.",
    date: "2012-12-31"
  },
  {
    title: "Comptes de la nation 2011",
    principalLink: "/documents/ComptesNational/",
    prixCourantLink: "/documents/ComptesNational/TRE-2011-CRT-V.xls",
    prixConstantLink: "/documents/ComptesNational/TRE-2011-CST-V.xls",
    image: 'assets/comptesNationaux/cover.PNG', 
    description: "Ce rapport présente les comptes de la nation pour 2011, offrant une vue d'ensemble sur l'économie à cette époque.",
    date: "2011-12-31"
  },
  {
    title: "Comptes de la nation 2010",
    principalLink: "/documents/ComptesNational/",
    prixCourantLink: "/documents/ComptesNational/TRE-2010-CRT-V-1.xls",
    prixConstantLink: "/documents/ComptesNational/TRE-2010-CRT-V-1.xls",
    image: 'assets/comptesNationaux/cover.PNG', 
    description: "Analyse des résultats économiques de 2010. Ce rapport est important pour comprendre les contextes économiques de cette année.",
    date: "2010-12-31"
  },
  {
    title: "Comptes de la nation 2009",
    principalLink: "/documents/ComptesNational/",
    prixCourantLink: "/documents/ComptesNational/TRE-2009-CST-V.xls",
    prixConstantLink: "/documents/ComptesNational/TRE-2009-CST-V.xls",
    image: 'assets/comptesNationaux/cover.PNG', 
    description: "Une revue des comptes nationaux de 2009, elle offre une vue d'ensemble importante sur les impacts des crises économiques.",
    date: "2009-12-31"
  },
  {
    title: "Comptes de la nation 2008",
    principalLink: "/documents/ComptesNational/",
    prixCourantLink: "/documents/ComptesNational/TRE-2008-CRT-V.xls",
    prixConstantLink: "/documents/ComptesNational/TRE-2008-CST-V.xls",
    image: 'assets/comptesNationaux/cover.PNG', 
    description: "Ce rapport sur les comptes nationaux pour 2008 examine les performances économiques avant la crise financière mondiale.",
    date: "2008-12-31"
  },
  {
    title: "Comptes de la nation 2007",
    principalLink: "/documents/ComptesNational/",
    prixCourantLink: "/documents/ComptesNational/TRE-2007-CRT-V.xls",
    prixConstantLink: "/documents/ComptesNational/TRE-2007-CST-V.xls",
    image: 'assets/comptesNationaux/cover.PNG', 
    description: "Dans ce rapport, les comptes de la nation de 2007 sont analysés pour les fluctuations observées dans l'économie burundaise.",
    date: "2007-12-31"
  },
  {
    title: "Comptes de la nation 2006",
    principalLink: "/documents/ComptesNational/",
    prixCourantLink: "/documents/ComptesNational/TRE-2006-CRT-V.xls",
    prixConstantLink: "/documents/ComptesNational/TRE-2006-CST-V.xls",
    image: 'assets/comptesNationaux/cover.PNG', 
    description: "Ce document donne un aperçu des comptes nationaux 2006, traitant de l'impact des politiques économiques nationales.",
    date: "2006-12-31"
  },
  {
    title: "Comptes de la nation 2005",
    principalLink: "/documents/ComptesNational/",
    prixCourantLink: "/documents/ComptesNational/TRE-2005-CRT-V.xls",
    prixConstantLink: "/documents/ComptesNational/",
    image: 'assets/comptesNationaux/cover.PNG', 
    description: "Ce rapport consacré aux comptes nationaux de 2005 examine les résultats économiques et les contextes politiques de l'époque.",
    date: "2005-12-31"
  }*/
];




const StyledButton = styled(Button)(({ theme }) => ({
  marginTop: '20px',
  backgroundColor: 'green',
  color: 'white',
  '&:hover': {
    backgroundColor: 'darkgreen',
  },
  '&:active': {
    backgroundColor: 'darkgreen',
  },
}));

function ComptesNationaux() {
  const [visibleCount, setVisibleCount] = useState(4);
  const [selectedYear, setSelectedYear] = useState('Tous');
  const [filteredComptes, setFilteredComptes] = useState([]);

  const handleShowMore = () => {
    setVisibleCount((prevCount) => prevCount + 2);
  };

  const handleYearChange = (event) => {
    const year = event.target.value;
    setSelectedYear(year);
    if (year === 'Tous') {
      setFilteredComptes([...comptesNationauxData].sort((a, b) => new Date(b.date) - new Date(a.date)));
    } else {
      const filtered = comptesNationauxData.filter((rapport) => {
        const rapportYear = new Date(rapport.date).getFullYear();
        return rapportYear === parseInt(year);
      }).sort((a, b) => new Date(b.date) - new Date(a.date));
      setFilteredComptes(filtered);
    }
  };

  useEffect(() => {
    
    handleYearChange({ target: { value: 'Tous' } });
  }, []);

  const StyledSelect = styled(Select)(({ theme }) => ({
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.main,
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.light,
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.dark,
    },
  }));

  const theme = createTheme({
  });

  return (
    <ThemeProvider theme={theme}>
      <div style={{ backgroundColor: theme.palette.background.default, paddingBottom: '32px' }}>
        <NavigationBar />
        <Container maxWidth="lg" style={{ paddingTop: '54px' }}>
          <Typography variant="h4" align="justify" gutterBottom style={{ color: 'green', marginBottom: '16px' }}>
            Comptes Nationaux
          </Typography>
          <Divider style={{ margin: '16px 0' }} />
          <Typography variant="body1" align="justify" paragraph style={{ marginBottom: '24px' }}>
            Le secteur des comptes nationaux joue un rôle essentiel en fournissant une évaluation détaillée des résultats de la comptabilité nationale. Il recueille et analyse des données sur l'évolution des comptes par secteur d'activité, incluant des produits variés tels que les notes d'analyse, ainsi que les rapports définitifs et provisoires pour l'année en cours, à prix courants et à prix constants. La méthodologie d'élaboration utilisée est conforme au Système de Comptabilité Nationale 1993 (SCN93), et les nomenclatures d'activités et de produits sont adaptées au contexte burundais, s'inspirant des standards d'AFRISTAT, y compris la Nomenclature d'Activités (NAEMA) et la Nomenclature de Produits (NOPEMA), elles-mêmes dérivant respectivement de la Classification Internationale Type par Industrie (CITI, révision 3) et de la Classification Centrale des Produits (CPC, révision 2).
          </Typography>

          <FormControl fullWidth variant="outlined" style={{ marginLeft: '0px', width: '300px' }}>
            <InputLabel id="year-select-label">Filtrer par année de publication</InputLabel>
            <StyledSelect
              labelId="year-select-label"
              id="year-select"
              value={selectedYear}
              onChange={handleYearChange}
              label="Filtrer par année de publication"
            >
              <MenuItem value="Tous">Tous les comptes</MenuItem>
              {[...new Set(comptesNationauxData.map((rapport) => new Date(rapport.date).getFullYear()))]
                .sort((a, b) => b - a)
                .map((year) => (
                  <MenuItem key={year} value={year.toString()}>
                    {year}
                  </MenuItem>
                ))}
            </StyledSelect>
          </FormControl>

          <Grid container spacing={1} style={{ marginTop: '5px' }}>
            {filteredComptes.slice(0, visibleCount).map((rapport, index) => (
              <Grid item xs={12} sm={12} key={index}>
                <Card elevation={3} style={{ borderRadius: '12px', overflow: 'hidden', display: 'flex', flexDirection: 'column', height: '100%' }}>
                  <Box sx={{ display: 'flex' }}>
                    <a
                      href={rapport.principalLink}
                      style={{ textDecoration: 'none', color: 'inherit' }}
                      target="_blank"
                      rel="noopener noreferrer"

                    >
                      <CardMedia
                        component="img"
                        sx={{ width: 91, height: 140, m: 2 }}
                        image={rapport.image}
                        alt={rapport.title}
                      />
                    </a>
                    <Box sx={{ display: 'flex', flexDirection: 'column', pl: 2, pt: 2 }}>
                      <Typography variant="h6" component="div" style={{ fontWeight: 'bold', marginBottom: '10px', color: 'green' }}>
                        <a
                          href={rapport.principalLink}
                          target="_blank"
                          rel="noopener noreferrer"
                         
                          style={{ textDecoration: 'none', color: 'inherit' }}
                        >
                          {<DownloadIcon />}
                          {rapport.title}
                        </a>
                      </Typography>
                      <Typography variant="body2" component="div" style={{ color: '#555', marginBottom: '10px' }}>
                        {rapport.description}
                      </Typography>
                      <Typography variant="caption" color="textSecondary">
                        Publié en {moment(rapport.date).format('MMMM YYYY')}
                      </Typography>
                      {rapport.prixConstantLink && (
                        <a
                          href={rapport.prixConstantLink}
                          style={{
                            marginTop: '10px',
                            color: 'green',
                            textDecoration: 'none',
                          }}
                          rel="noopener noreferrer"
                        >
                          Prix Constant
                        </a>
                      )}
                      {rapport.prixCourantLink && (
                        <a
                          href={rapport.prixCourantLink}
                          style={{
                            marginTop: '5px',
                            color: 'green',
                            textDecoration: 'none',
                          }}
                          rel="noopener noreferrer"
                        >
                          Prix Courant
                        </a>
                      )}
                    </Box>
                  </Box>
                </Card>
              </Grid>
            ))}
          </Grid>

          {visibleCount < filteredComptes.length && (
            <StyledButton onClick={handleShowMore}>
              Plus de comptes
            </StyledButton>
          )}
          <br />
          <br />
        <Typography variant="body1" align="justify" paragraph style={{ marginBottom: '24px', lineHeight: 1.6 }}>
        <strong>Note :</strong> Les Comptes Nationaux sont publiés trimestriellement, généralement <strong>90 jours</strong> après la clôture de chaque trimestre, selon le calendrier suivant :
        <ul style={{ listStyleType: 'circle', margin: '10px 0 10px 20px', padding: 0 }}>
              <li><strong>30 juin Année N</strong> - Publication des données du premier trimestre (T1)</li>
              <li><strong>30 septembre Année N</strong> - Publication des données du deuxième trimestre (T2)</li>
              <li><strong>31 décembre Année N</strong> - Publication des données du troisième trimestre (T3)</li>
              <li><strong>31 mars Année N+1</strong> - Publication des données du quatrième trimestre (T4)</li>
        </ul>
</Typography>
        </Container>
        <Footer />
      </div>
    </ThemeProvider>
  );
}

export default ComptesNationaux;